<ngx-ui-loader></ngx-ui-loader>
<router-outlet *ngIf="(loginSuccess==2)"></router-outlet>
<app-error *ngIf="(loginSuccess==3)"></app-error>